import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editDomain } from "../store/reducers/domainSlice.js";
import { translate } from '../i18n';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

// AntSwitch (inchangé)
const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'limegreen',
      boxSizing: 'border-box',
    },
  }));

  const Domain_Switch = () => {

  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const language_code = useSelector((state) => state.lang);

  const changeDomain = (event) => {
    const isChecked = event.target.checked;
    console.log("The domain event", isChecked);
    setChecked(isChecked);
    dispatch(editDomain(isChecked ? "pastoral" : "agro"));
  };

  return (
    <FormGroup>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography className='domain-agro-label'>
          {translate('top_header', language_code.lang).agro}
        </Typography>
        {/* Cible de l'infobulle « Le saviez-vous ? » (secteur agricole / pastoral) */}
        <span data-tour="domain" style={{ display: 'inline-flex' }}>
          <AntSwitch
            inputProps={{ 'aria-label': 'ant design' }}
            checked={checked}
            onChange={changeDomain}
          />
        </span>
        <Typography className='domain-pastoral-label'>
          {translate('top_header', language_code.lang).pastoral}
        </Typography>
      </Stack>
    </FormGroup>
  );
};

export default Domain_Switch;
